import { Component } from '@angular/core';

@Component({
  selector: 'ws-site-doctors',
  templateUrl: './doctors.component.html'
})
export class SiteDoctorsComponent {}
